import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { authFeature } from '../auth/auth.feature';

export const authGuard: CanActivateFn = (): any => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(authFeature.selectUid).pipe(
    take(1),
    map((uid): boolean | UrlTree => (uid ? true : router.parseUrl('/login')))
  );
};
